import { MouseEventHandler } from "react";
import { Box, IconButton } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Slider from "react-slick";
import { useBanners } from "../../hooks/queries/useBanners";

import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

// Types
interface BannerData {
  id: number;
  image: string;
  url: string;
  urlType: string;
}

type ImagePropType = { src: string };
const Image = ({ src }: ImagePropType) => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: 230,
      background: `url(${src}) no-repeat center center`,
      backgroundSize: "cover",
    }}
  />
);

type BannerPropType = {
  banner: BannerData;
};
const Banner = ({ banner }: BannerPropType) => {
  if (banner.url) {
    return (
      <a
        href={banner.url}
        target={banner.urlType === "I" ? "_self" : "_blank"}
        rel="noreferrer"
        style={{ display: "block" }}
      >
        <Image src={banner.image} />
      </a>
    );
  }

  return (
    <div>
      <Image src={banner.image} />
    </div>
  );
};

type NavArrowPropType = {
  onClick?: MouseEventHandler<HTMLButtonElement>;
};
const NextArrow = ({ onClick }: NavArrowPropType) => {
  return (
    <Box position="absolute" top="50%" marginTop="-12px" right={10} zIndex={1}>
      <IconButton
        aria-label="next"
        onClick={onClick}
        size="small"
        sx={{
          background: "rgba(255, 255, 255, 0.5)",
          "&:hover": {
            background: "rgba(255, 255, 255, 0.8)",
          },
        }}
      >
        <ArrowForwardIosIcon />
      </IconButton>
    </Box>
  );
};

const PrevArrow = ({ onClick }: NavArrowPropType) => {
  return (
    <Box position="absolute" top="50%" marginTop="-12px" left={10} zIndex={1}>
      <IconButton
        aria-label="prev"
        onClick={onClick}
        size="small"
        sx={{
          background: "rgba(255, 255, 255, 0.5)",
          "&:hover": {
            background: "rgba(255, 255, 255, 0.8)",
          },
        }}
      >
        <ArrowBackIosIcon />
      </IconButton>
    </Box>
  );
};

const settings = {
  dots: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 7000,
  pauseOnHover: true,
  swipeToSlide: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
};

const Banners = () => {
  const { data: banners = [] } = useBanners();

  return (
    <Box marginBottom={4}>
      <Slider {...settings} infinite={banners.length >= 2}>
        {banners.map((banner: BannerData) => (
          <Banner key={banner.id} banner={banner} />
        ))}
      </Slider>
    </Box>
  );
};

export default Banners;
